import * as React from 'react'
import {connect} from 'react-redux'

import Builds from '../components/common/Builds/Builds.container'
import BuildsFilters from '../components/common/BuildsFilters/BuildsFilters.container'
import BuildPager from '../components/common/Pager/BuildPager/BuildPager.container'
import {submitPager} from '../components/common/Pager/Pager.actions.base'
import type {Pager} from '../components/common/Pager/Pager.types'
import type {AgentFilter} from '../types'

import BuildLineLayout from './BuildLineLayout'
import BuildsFetcher from './BuildsFetcher'

export type AgentHistoryProps = {
  agent?: AgentFilter
  withAgentPatternFilter?: boolean
}
type ActionProps = {
  submitPager: (pager: Partial<Pager>) => unknown
}
type Props = AgentHistoryProps & ActionProps
const initialPager: Partial<Pager> = {
  lookupLimit: 1000000,
  lookupDelta: 1000000,
}
const actionCreators: ActionProps = {
  submitPager,
}

class AgentHistory extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    props.submitPager(initialPager)
  }

  render() {
    return (
      <BuildsFetcher agent={this.props.agent} withPager updatePeriod={180000}>
        <BuildLineLayout showAgent={!!this.props.withAgentPatternFilter}>
          <BuildsFilters
            withPager
            disableAdvancedMode
            withProjectBuildtypeFilter
            filterBuildtypes
            withStateFilter
            showUpdateResults
            withAgentPatternFilter={this.props.withAgentPatternFilter}
          />
          <Builds alwaysShowLineBorders showOverlayOnLoading withPager placeholder="" withLoader />
          <BuildPager />
        </BuildLineLayout>
      </BuildsFetcher>
    )
  }
}

export default connect(null, actionCreators)(AgentHistory) as React.ComponentType<AgentHistoryProps>
